import React, { FC } from 'react'
import { Header as LunaHeader } from '@sainsburys-tech/luna-header'
import TopHeader from "./TopHeader";
import Navbar from "./Navbar";
import './index.scss'

const Header: FC = () => {
    return (
        <>
        <TopHeader/>
        <LunaHeader><Navbar /></LunaHeader>
        
            {/* <LunaHeader>
                <TopHeader/>
            </LunaHeader>
            <LunaHeader>
                <Navbar />
            </LunaHeader> */}
        </>
    )

}

export default Header;